module.exports = __webpack_public_path__ + "img/stock2.6b60e4b5.png";